module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/large.be5121d350dd3e3ac97e.jpg";